var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
/**
 * @link https://branch.invisionapp.com/dsm/branch-metrics/dashboard/asset/icons/5dd9a2ca0894348e515bebbf
 */
export function Tips(props) {
    const { testid } = props, rest = __rest(props, ["testid"]);
    return (React.createElement("svg", Object.assign({ width: 20, height: 20, "data-testid": testid, viewBox: "0 0 20 20" }, rest),
        React.createElement("defs", null,
            React.createElement("path", { d: "M7.5 17.5c0 .458.375.833.833.833h3.334a.836.836 0 00.833-.833v-.833h-5v.833zM10 1.667A5.84 5.84 0 004.167 7.5a5.83 5.83 0 002.5 4.783v1.884c0 .458.375.833.833.833h5a.836.836 0 00.833-.833v-1.884a5.83 5.83 0 002.5-4.783A5.84 5.84 0 0010 1.667zm2.375 9.25l-.708.5v1.916H8.333v-1.916l-.708-.5A4.164 4.164 0 015.833 7.5C5.833 5.2 7.7 3.333 10 3.333S14.167 5.2 14.167 7.5a4.164 4.164 0 01-1.792 3.417z", id: "prefix__a" })),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M0 0h20v20H0z" }),
            React.createElement("path", { d: "M0 0h20v20H0z" }),
            React.createElement("mask", { id: "prefix__b", fill: "#fff" },
                React.createElement("use", { xlinkHref: "#prefix__a" })),
            React.createElement("use", { fill: "#000", xlinkHref: "#prefix__a" }),
            React.createElement("g", { mask: "url(#prefix__b)", fill: "#8547AD" },
                React.createElement("path", { d: "M0 0h20v20H0z" })))));
}
//# sourceMappingURL=Tips.js.map